import React, { useState } from 'react';
import styled from 'styled-components'
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
// import SpeedOutlinedIcon from '@material-ui/icons/SpeedOutlined';
import UpdateOutlinedIcon from '@material-ui/icons/UpdateOutlined';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { useEffect } from 'react';
import FinReport from './FinReport';
  
const UL = styled.ul`
list-style-type: none;
display: flex;
justify-content: space-around;
align-items: space-between;
height: 25rem;
background: white;
max-width: 50%;
width: 50%;
flex-flow: column;
margin-top: 3rem;
font-weight: bold;
padding-inline-start: .3rem;
padding-inline-end: .3rem;
flex-wrap: wrap;
border-radius: .5rem;
box-shadow: .2rem .3rem .3rem silver;
transition: ease-in-out 1.2s;

&:hover {
    transform: translateY(-.7rem);
    background: grey;
    transition: ease-in-out 1s;
}


@media screen and (max-width: 48rem) {
    width: 70rem;
    max-width: 24rem;
 
}
@media screen and (min-width: 48rem) {
    width: 33%;
 
}
 
`

const LI = styled.li`
margin-top: .5rem; 
flex: 1;


&:first-child {
    font-size: larger;
    text-align: center;
}
&:nth-child(4) span p {
   border: 2px dashed #a4508b;
   padding: .5rem;
   overflow: auto;
   width: fit-content;
   word-break: break;
   height: fit-content;
   margin: 0rem auto .5rem 0rem;
   line-height: 2rem;
   font-weight: normal;
}
`
 
const LDailyPills = ({moneyLeft, weekly, getWeekly, transType = 'Money left / Latest transactions', daily, getMonthly, Monthly = [], getDaily })=> {

    const[compoArr, setCA] = useState([])
    const[monSpendTot, setMST] = useState(0)
    const[monGainTot, setMGT] = useState(0)
    const[Total, setMT] = useState(0)
    const[spendArr, setSA] = useState([])
    const[gainArr, setGA] = useState([])
    const[budgI, setBI] = useState('')

   

    useEffect(() => {
            if(compoArr.length >= 1) {

                 setBI(compoArr.map(s => s.budg))
                setSA(compoArr.filter(s => s.spendBol === true).map(s => s.diff) )
                setGA(compoArr.filter(s => s.spendBol === false).map(s => s.diff) )
                
                if(compoArr.filter(s => s.spendBol === true).length >= 1) {
                    let moneySpendArr = compoArr.filter(s => s.spendBol === true).map(s => s.diff).reduce((prev, currv) => prev + currv).toFixed(5)
                    setMST(Number(moneySpendArr))
                }
                if( compoArr.filter(s => s.spendBol === true).length < 1 ) {
                    setMST(Number(0))

                }
                if(compoArr.filter(s => s.spendBol === false).length >= 1) {
                    let moneyGainArr = compoArr.filter(s => s.spendBol === false).map(s => s.diff).reduce((prev, currv) => prev + currv).toFixed(5)
                     setMGT(Number(moneyGainArr))

                }
                if(compoArr.filter(s => s.spendBol === false).length < 1) {
                    setMGT(Number(0))

                }
                
                if(compoArr.map(s => s.money).length >= 1) {
                    let balc = compoArr.map(s => s.money).reduce((prev, currv) => prev + currv).toFixed(5)
                    setMT(Number(balc))
                }
// let empty = []
//                 if(spendArr.length >=1 && gainArr.length >=1) {
//                     if(spendArr.length > gainArr.length) {
//                         for (let i = 0; i < spendArr.length; i++) {
                             
//                         }
//                     }
//                 }

                // setMT( Number(moneyArr) )
                // console.log(compoArr.filter(s => s.spendBol === true).map(s => s.diff) )
                }
        },[setMT, compoArr])

    

  useEffect(() => { 
     if(transType === 'Weekly transactions') {
         if(weekly.length < 1) {
            getWeekly()
        }
    //  else if(transType === 'Daily transactions') {
    //       console.log('yea, daily works')
    //          getDaily()
          
    //  }
         
    } 
    else if(transType === 'Money left / Latest transactions') {
        
        setCA(moneyLeft)
         
    } 
    
        },[getWeekly, transType, moneyLeft, weekly, ])

        useEffect(() => {
            
           setCA(weekly)
        },[weekly])

        useEffect(() => {
            if(transType === 'Daily transactions') {
                  getDaily()

                  
            }
        }, [getDaily, transType])
        useEffect(() => {
            if(daily.length >= 1) {
                setCA(daily)
            }
            else setCA([])
        },[daily])
        // useEffect(() => {
        //     if(transType === 'Weekly transactions') {
        //         setCA(weekly)
                 
        //     } 
        // }, [weekly, transType])
        
        useEffect(() => {
            if(transType === 'Monthly transactions'  && Monthly.length < 1) {
              getMonthly()
             }
        }, [getMonthly, transType, Monthly])

        useEffect(() => {
            if(transType === 'Monthly transactions') {
                setCA(Monthly)
                 
            }
        }, [Monthly, transType])
    
        const ReportMan = (spendAmt, recivAmt) => {
            if(recivAmt > spendAmt) {
                if(transType === 'Daily transactions') {

                    return `Gooday, am happy for you, you seem to save more money today, pls Keep it up. Thanks!`
                } 
            else if(transType === 'Money left / Latest transactions') {
                return `Gooday, Your savings scales higher, I encourage you maintain this kind of results over the years`

                }
            else if(transType ==='Weekly transactions') {
                return `great week so far, bravo!!! Your savings scales higher so far this week, keep it up `

                }
             else {
                return `Gooday, Your savings scales higher, I encourage you maintain this kind of results over the years`
                }
            
            }
            else {
                if(transType === 'Daily transactions') {

                    return `How is your day going? your expenses tend to scale higher today, we advise you spend less and save more`
                } 
            else if(transType === 'Money left / Latest transactions') {
                return `Your savings seems to be lower in scale, pls check your past expenses and reduce them, thanks`

                }
            else if(transType ==='Weekly transactions') {
                return `This week it seems money left your hands more, pls I advise you check your records and save more money next week, thanks `

                }
             else {
                return `Over the month you have really spent much, well, I advise you check your records and save more money against the coming month, thanks`
                }
            }
        }
    
   if(compoArr.length > 0) {
    return ( 
        <>
         <FinReport
         monSpendTot={monSpendTot}
         monGainTot={monGainTot}
         balc={Total}
         spendArr={spendArr}
         gainArr={gainArr}
         reportSheet = {ReportMan}
         label={budgI} />
        <section style={{display:'flex', flexWrap:'wrap', justifyContent: 'space-around', maxWidth: '100%', flex:'1', alignContent:'center'}} >
            {
                compoArr.map((s, i) =>
                <UL key={i}>
                <LI> { s.budg } </LI>
                <LI> { s.rPerc }% </LI>
              <LI><AccountBalanceOutlinedIcon style={{color:'silver', marginRight: '2rem', verticalAlign: 'sub', fontSize:'30'}}  /> N { s.money }<span style={{color:'silver'}}> (bal)</span> | <span style={s.spendBol ? {color:'red'}:{color:'green'} }>N {s.diff ? s.diff : ''}</span> </LI>
               
                <LI> <span><p>  { s.purpose } </p>  </span>  </LI>

                 <LI> { s.spendBol ? <WarningOutlinedIcon style={{color:'red', marginRight: '2rem', verticalAlign: 'sub'}}  />  :
                <CheckCircleOutlineOutlinedIcon style={{color:'green', marginRight: '2rem', verticalAlign: 'sub', fontSize:'30'}}  />  }  
                   { s.spendBol ? 'money spent / withdrawn'  :
                  'money recived / gain '  }  
                 
                  </LI>
                 <LI>  <UpdateOutlinedIcon style={{color:'silver', marginRight: '2rem', verticalAlign: 'sub', fontSize:'30'}}  /> 
                 {s.day} {s.month} {s.dayNo} | {s.timeTrans} 
                  
                 
                  </LI>
            </UL>
         
         
                  )
            }
        </section>
            

         
   
    
   

        </>
     
    );
} 
    return (
        <div style={{textAlign:'center'}}>Waiting / No data availiable</div>
    )
   }  

   
 
export default LDailyPills;